
import api from "../../../../api/api"

const getItemList = () =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/transaction-report").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getItemListByProject = (projectId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/transaction-report/project/"+projectId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}



const transactionReportServices = {
    getItemList,
    getItemListByProject,
}
export default transactionReportServices;